import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { theme } from '../../../../../ui';
import { toRgba } from '../../../../../ui/theme/colors';
import { DragHandle, MenuButton } from './EditControls';

const ItemBase = styled.div`
  padding: 8px 16px;
  margin: 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  background: ${({ $sectionIsActive, $lightColor }) => ($sectionIsActive ? $lightColor : theme.colors.NEU_0)};
  pointer-events: ${({ $isMoving }) => ($isMoving ? 'none' : 'auto')};
  transition: background-color 0.15s;

  &:hover {
    background-color: ${({ $sectionIsActive, $lightColor }) => ($sectionIsActive ? $lightColor : theme.colors.NEU_100)};

    &::after {
      content: ${({ $sectionIsActive }) => ($sectionIsActive ? "''" : 'none')};
      position: absolute;
      inset: 0;
      background-color: ${toRgba(theme.colors.NEU_999, 0.04)};
      pointer-events: none;
    }
  }
`;

const ItemActive = styled(ItemBase)`
  position: relative;
  background-color: ${({ $lightColor }) => $lightColor || theme.colors.PRIMARY_LIGHT};

  &:before {
    content: '';
    border-left: 6px solid ${({ $darkColor }) => $darkColor || theme.colors.PRIMARY};
    position: absolute;
    width: 6px;
    height: 100%;
    left: 0;
    top: 0;
  }

  &:hover {
    background-color: ${({ $lightColor }) => $lightColor || theme.colors.PRIMARY_LIGHT};
  }
`;

const ItemLocked = styled(ItemBase)`
  pointer-events: none;
  opacity: 0.6;
`;

const ItemContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  &:hover ${DragHandle}, &:hover ${MenuButton} {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
`;

/**
 * PageItem - Renders a page item with appropriate styling based on state
 */
const PageItem = forwardRef(({ isActive, isLocked, isMoving, sectionIsActive, lightColor, darkColor, onClick, onContextMenu, children }, ref) => {
  const Component = isLocked ? ItemLocked : isActive ? ItemActive : ItemBase;

  return (
    <Component
      ref={ref}
      onClick={onClick}
      onContextMenu={onContextMenu}
      $lightColor={lightColor}
      $darkColor={darkColor}
      $isMoving={isMoving}
      $sectionIsActive={sectionIsActive}
    >
      <ItemContent>{children}</ItemContent>
    </Component>
  );
});

PageItem.displayName = 'PageItem';

export default PageItem;
